import html2canvas from 'html2canvas';
import Vue from 'vue';
import DDLogs from '@/DDLogs';
import shareEvents from '@/utils/shareEvents';
import MobileMessagesUtils from '@/utils/mobileMessagesUtils.js';
import { isNativeApp } from '@/utils/deviceUtils';

const SHARE_IMPRESSION_OPTIONS = {
  ON_CLICK: 'onClick',
  ON_SHOW: 'onShow',
  NEVER: 'never',
};

function webShareSupported() {
  return (navigator && navigator.share) !== undefined && _verifyShareIsSupported();
}

function _verifyShareIsSupported() {
  if (!navigator.canShare) {
    return false;
  }
  // eslint-disable-next-line
  const exampleDataUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAkQAAAAgCAYAAADzGmc/AAAAAXNSR0IArs4c6QAACIVJREFUeF7t3XdQVEcABvAPEZ1ETSZFESVYsMcSoyZY4hAbEhMVErHFQlSsWIKCig0sJAJijWINGiFYsGMZjcbYUVBQFMU+GlvsiQUjmV3mnveO4854dwjHt/84d2/Z2/d7z5lv9u3btcnMzMwECwUoQAEKUIACFCjAAjYMRAX46vPUKUABClCgQAncun0X67fulOdc0ckRro0bvPbzP34qHYeSUmQ/Pv24Fj6sWknVJ+0+O5V1QIumLhbpMwORRVjZKAUoQAEKUCDvCZw8cw5evf1kx2pWq4SYyNDX3snouE0ImbFQ9qO7V1uMGOit6pN2n53Lf4C1UTMt0mcGIouwslEKUIACFKBA3hNgIMr5mjAQ5b37lT2iAAUoQAEKWESAgYiByCI3FhulAAUoQAEK5CcBBiIGovx0v7KvFKAABShAAYsIMBAxEFnkxmKjFKAABShAgfwkwEDEQJSf7lf2lQIUoAAFKGARgdwKRGKJQxsbm5c6B75l9lJMrEQBClCAAhSggLkE9AWi1LSz2HMoCYnJqTh6/BSKFi2C6pUrokPbVnBt1AC2trZGf/7MuYvY8cdBnDiVjoSjx/H3P49gX/I9NG/qgrZurtnWFtJu0NyBKC39AvYmJEH8m5qWjguXr6KKc3k4l3dErepV4NmmBYq9+Ua2c+JbZkYvMytQgAIUoAAFrENANxB5d/aA3/ic1yJq2rA+pgWNkCFJXxEjQTFr4pV1hHJS+qqVK4IDBqFw4ezhylyB6MnTDMyLisXCX1YbvFgiDPn174EObd1U9RiIrOMe51lQgAIUoAAFjApoByLdyu++8zaePHkqR3e0ixhRCfIfqLftgIkRiN++W3VMLPj4NOMZTp+9oPr+8yafICLYP9uIkzkC0Z2799F90Cg5GqRdRPgRYe72nXvZ+i8WgBQLQWoKA5HR24cVKEABClCAAtYhoC8QNaxfRwYeB/uSECM+x06kYewPs1ThYsuv81DWwV6FsHv/EQwcOUn5LsC3Fzp7uCuB59Hjx5gXtRKLo+OUOlPH+cG9eRNVO+YIRGNCZmLdlqwtSUTp2L41vDu1R5nSpeRcpvsPHuL3/YcxOWK+KvBFho1HowYfyb9hILKOe5xnQQEKUIACFDAqoBuIateogqWzp2Qbtbl6/SbcvHyU9gKH+qCTh7vyOSPjGTy9hyihaebkURAjQPpK5NKVmL0oWh4SW2/ELZmBQoVeTLg2NRAdTExB72HjDIYuzcFrN26ho89wZcSoQd2aWDx9IgOR0TuHFShAAQpQgAJWJKAbiLRHSHRPc8qMBYiJi5df6+4xpj06JCZezwoZnaOSCE/unfvh+s2/ZJ0VC8PlpG1NMTUQiTAkQpEozT9zwfRJAQav2OYde+AfHK7UiVsyHZUrluMIkRXd5zwVClCAAhSggEEB3UCUuH0l7OwK6/2bVRu2IShsrjwmHnOJx12aEhW7DmE//Sw/jv2+H7zaqSco6zYoHsGt3fyb/FoEFhFczBWIXNy7KI/BVi+OkG+UGSrisWDLDn2UgBY63g+tmzVhIOL/HQpQgAIUoEBBEdAOROK1+O2rsnaZ11d27U2A7+gp8pDb540RNmG4Um381DmI27Rd+SwmZBsq2pOadSczmzJCdOPWbTT/upfy00k7Vul9k023b4MDQ7BzzyH59VCfbujV1ZOBqKD8J+B5UoACFKAABf7Pwoy79iXAd5T+QCTe6EpKOfVKoN918cSwvt2UvzUlEGnPH3IsY4/NMfNeqk+hc5Zg6Yr1sq7mcSAnVb8UHStRgAIUoAAF8r+AuQJRD99AuZCjKNWrVISjzhtohqTE47I2LZuaPRCJV+wPbM6avG2sjJ48Axu27ZLVxNtx337zJUeIjKHxOAUoQAEKUMBaBMwViMb9OBtr4ndIlvCgEWjl2uiViUwZIbp05U+06TJA+e29G5fhrRLFjfbFq48fTp4+J+stmDYBLvXqMBAZVWMFClCAAhSggJUImCsQab9K36m9OwKHvXhFX5fq2bN/kZyapnxdu0ZV1TwfUwLR04wM1GvhpbQ9JXAIxKrYhkr6+Uvw6DlEqSLmUYn5VHxkZiU3OU+DAhSgAAUoYEzAXIEoOfU0uvZ/8Xr7+mWzUcGprN6fnz5/GRYtz1qcUQSPrbGRqnWPTAlEok2x9ci2Xftk+2Jyd3z0XL17lWk65+M3AfsPH5MfxeO+2PlhcvFGBiJjdw+PU4ACFKAABaxEwFyBSHBozyMSr7pPC/ZHOUcHldSeg4no75+18KEoYkVssRWIdjE1EOmGM7HYZMiYoXAqq+7LvfsPERw+VwlPog8rFoTLUCQKA5GV3OQ8DQpQgAIUoIAxAXMGosSUk+gxSL0go9gyo1qlCrIbB44kY+vOvUqX6taqhoURwShiZ2fWQCQa015EUtO4WDupqnNWXy5cvoLdB46o9jTr0bEdhg/oqfSFgcjY3cPjFKAABShAASsRMGcgEiS6I0A5MYlRmEURwShRvFi2KqaOEIkGnz/PxITQOcpEb2OXa3CfrvDu5KGay8RAZEyNxylAAQpQgAJWInDm3EV4eg+VZyN2pY+JDM3xzPYlHEXf4UHyeHv3Zpg40ldvXRGylq/aqNpcVVNRzOnp37MjPL5ogaJF1CNDmjqx67Zg0rRI+VF3ixDxnXafxV5oa6Nm5tjng0eSMWdJTI5rJImNbMXCkGKrDt3CQGQlNzlPgwIUoAAFKPA6Be7cu4+z5y/j3oMHclKzo0NpONi/n23j2Nzoo9jd/vLVa7h67SZsCxWCcwUnODqUMtgXBqLcuDL8DQpQgAIUoAAF8rQAA1GevjzsHAUoQAEKUIACuSHAQJQbyvwNClCAAhSgAAXytAADUZ6+POwcBShAAQpQgAK5IcBAlBvK/A0KUIACFKAABfK0wH/kJlTdd3X0HQAAAABJRU5ErkJggg==';
  const blob = dataURItoBlob(exampleDataUrl);
  const filesArray = [new File([blob], 'test.png', { type: blob.type })];
  const shareData = { files: filesArray };
  return navigator.canShare(shareData);
}

// this function is very useful for debugging on mac and download the screenshot
async function downloadCanvas(canvas, filename = 'download.png', segmentData = {}) {
  const dataUrl = canvas.toDataURL();
  const download = document.createElement('a');
  download.href = dataUrl;
  download.download = filename;
  download.click();
  shareEvents.trackShareSucceeded({ ...segmentData, download: true });
}

async function createCanvas(shareComponent, shareComponentProps, parentNode) {
  const MyClass = Vue.extend(shareComponent);
  const instance = new MyClass({
    propsData: shareComponentProps,
  });
  instance.$mount();
  instance.$el.style.position = 'fixed';
  instance.$el.style.visibility = 'hidden';
  parentNode.appendChild(instance.$el);
  try {
    return await createShareAsset(instance.$el, (doc, el) => {
      // eslint-disable-next-line no-param-reassign
      el.style.visibility = 'visible';
    });
  } finally {
    parentNode.removeChild(instance.$el);
  }
}

async function createShareAsset(element, onClone) {
  // Seems like the html2canvas function takes a lot of CPU before it starts it async work, so if we're running it without the wait,
  // There is a render issue that seems stuck (the loader doesn't start the render)
  await waitFor(0);
  return await html2canvas(element, {
    useCORS: true,
    onclone: onClone,
  });
}
async function waitFor(ms = 0) {
  return new Promise(res => { setTimeout(res, ms); });
}

async function baseShare(shareData, segmentData) {
  try {
    await navigator.share(shareData);
    DDLogs.log('Done sharing');
    shareEvents.trackShareSucceeded(segmentData);
  } catch (error) {
    if (['AbortError', 'NotAllowedError'].includes(error.name)) {
      DDLogs.log('Canceled sharing');
      shareEvents.trackShareCanceled(segmentData);
    } else {
      DDLogs.error('Failed sharing', { error: error.message });
      shareEvents.trackShareFailed(segmentData);
    }
  }
}

async function shareAsImage(canvas, filename, segmentData = {}) {
  const dataUrl = canvas.toDataURL();
  if (isNativeApp()) {
    MobileMessagesUtils.dispatchMessageToMobile(MobileMessagesUtils.MOBILE_MESSAGES_NAME.SHARE_IMAGE, { dataUrl, filename });
  } else {
    const blob = dataURItoBlob(dataUrl);
    const filesArray = [new File([blob], filename, { type: blob.type })];
    await baseShare({ files: filesArray }, segmentData);
  }
}

async function shareImage(canvas, filename, segmentData = {}, forceDownload = false) {
  if ((!webShareSupported() && !isNativeApp()) || forceDownload) {
    await downloadCanvas(canvas, filename, { ...segmentData, forceDownload });
  } else {
    await shareAsImage(canvas, filename, segmentData);
  }
}

async function shareLink(link, text, segmentData) {
  if (isNativeApp()) {
    MobileMessagesUtils.dispatchMessageToMobile(MobileMessagesUtils.MOBILE_MESSAGES_NAME.SHARE_LINK, { link, text });
  } else if (webShareSupported()) {
    await baseShare({ url: link, text }, segmentData);
  } else {
    shareEvents.trackShareSucceeded(segmentData);
    const textWithLink = text ? encodeURIComponent(`${text}\n${link}`) : link;
    window.open(`https://api.whatsapp.com/send?text=${textWithLink}`, '_blank');
  }
}

// Taken from here: https://gist.github.com/davoclavo/4424731
function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  const byteString = atob(dataURI.split(',')[1]);
  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  // write the bytes of the string to an ArrayBuffer
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const _ia = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    _ia[i] = byteString.charCodeAt(i);
  }
  const dataView = new DataView(arrayBuffer);
  return new Blob([dataView], { type: mimeString });
}

export default {
  webShareSupported,
  shareImage,
  shareLink,
  downloadCanvas,
  createCanvas,
  createShareAsset,
  SHARE_IMPRESSION_OPTIONS,
};
